{
  "changeChain": {
    "title": "Select a chain"
  },
  "checkoutBlocked": {
    "notAvailable": "Not available",
    "regionMessage": "This service is not available in your region.",
    "viewRegions": "View available regions."
  },
  "common": {
    "addressCopied": "Address copied",
    "back": "Back",
    "cancel": "Cancel",
    "close": "Close",
    "confirm": "Confirm",
    "continue": "Continue",
    "copied": "Copied!",
    "copy": "Copy",
    "copyAddress": "Copy address",
    "done": "Done",
    "go": "Go",
    "loading": "Loading…",
    "ok": "OK",
    "poweredBy": "powered by",
    "tryAgain": "Try again",
    "startOver": "Start over"
  },
  "depositAmount": {
    "amountLabel": "Amount",
    "changeToMaximum": "Change to maximum",
    "changeToMinimum": "Change to minimum",
    "delete": "Delete",
    "enterAmount": "Enter an amount",
    "fee": "{{amount}} fee",
    "maximumAmount": "Maximum deposit {{amount}}",
    "minimumAmount": "Minimum deposit {{amount}}",
    "title": "Deposit",
    "submit": "Deposit",
    "submitWithMethod": "Deposit with {{method}}"
  },
  "feeDetails": {
    "amount": "Amount",
    "fee": "Fee {{rate}}",
    "summaryAddedToCharge": "{{method}} deposits incur a {{rate}} fee which will be added to your total charge.",
    "summaryDeductedFromDeposit": "{{method}} deposits incur a {{rate}} fee which will be deducted from the amount you receive.",
    "title": "Fee details",
    "totalCost": "Total cost",
    "youllGet": "You’ll get"
  },
  "fiat": {
    "agreeAndContinue": "Agree terms and Continue",
    "amountLabel": "Deposit amount",
    "applePay": "Apple Pay",
    "applePayNotSetUp": "Add a card to Apple Wallet, then try again.",
    "applePayUnsupported": "This device can't pay with Apple Pay.",
    "blocked": "Deposits aren't available in your region",
    "card": "Card",
    "contactVerifyBoth": "Please verify your phone number and email address",
    "contactVerifyEmail": "Please verify your email address",
    "contactVerifyPhone": "Please verify your phone number",
    "countryHeading": "Your Country",
    "countrySearchPlaceholder": "Search",
    "delete": "Delete",
    "deposit": "Deposit",
    "depositReceived": "{{amount}} deposit received",
    "depositReceivedFrom": "from {{method}}",
    "emailPlaceholder": "Your email",
    "failure": "Deposit failed",
    "fee": "{{amount}} fee",
    "getNewPrice": "Get a new price",
    "kycConsentCheck": "I consent to Fun verifying my identity and sharing the result with the payment provider that completes my order. See our",
    "kycConsentPrompt": "By continuing, you consent to Fun verifying your identity and sharing the result with the payment provider that completes your order. See our",
    "kycConsentStop": ".",
    "kycDetailAddress": "Your Address",
    "kycDetailDob": "Please enter your date of birth",
    "kycDetailName": "Your Name",
    "kycDetailNationality": "Your nationality",
    "kycDetailOther": "Please provide the remaining details",
    "kycDetailSsn": "Please provide your SSN",
    "kycFileUnsupported": "Document upload isn't available here yet — you'll be able to finish this step soon.",
    "kycFormDetail": "A few details are needed before your first deposit.",
    "kycFormInvalid": "Some of these details need another look.",
    "kycPhoneInUse": "This phone number is already used with another {{provider}} account. Use a different number.",
    "kycTaxIdInUse": "This tax ID is already used with another {{provider}} account.",
    "kycFormMissing": "Some required details are missing.",
    "kycFormStale": "This step moved on. Please check the details below.",
    "kycFormTitle": "Verify your identity",
    "kycIntroDetail": "This helps us process your deposits while keeping your account secure. It only takes a minute and no ID documents are required.",
    "kycNoticeCountryCode": "Use the two-letter country code, like AU",
    "kycNoticeDateFormat": "Use the format YYYY-MM-DD",
    "kycNoticeDatePast": "Enter a date in the past",
    "kycNoticeInvalid": "Please check the highlighted fields",
    "kycNoticeRequired": "Please fill in the highlighted fields",
    "kycNoticeUnderage": "You must be at least 18 to continue",
    "kycOnHold": "Verification on hold",
    "kycOnHoldDetail": "You can come back and try again later.",
    "kycOnHoldUntil": "You can try again on {{date}}.",
    "kycOpenLink": "Continue verification",
    "kycOptional": "optional",
    "kycPrivacyPolicy": "Privacy Policy",
    "kycProviderGeneric": "the payment provider",
    "kycProviderGenericId": "our verification partner",
    "kycProviderTerms": "{{provider}}’s terms and conditions",
    "kycProviderTermsPrompt": "By continuing, you agree to",
    "kycRejected": "Verification unsuccessful",
    "kycRejectedSupport": "Contact support and we'll look into it.",
    "kycRequired": "Verify & Deposit",
    "kycRequiredCta": "Verification Needed →",
    "kycRequiredDetail": "Please complete verification to proceed with your deposit.",
    "kycRequiredTitle": "Identity Verification Required",
    "kycCompleteDetail": "Your deposit limit has been increased.",
    "kycCompleteTitle": "ID Verification Completed",
    "kycHardCta": "See Options →",
    "kycHardDetail": "We cannot increase your deposit limit with ID verification.",
    "kycHardTitle": "Unable to Verify ID",
    "kycPendingCta": "Awaiting Verification →",
    "kycPendingDetail": "We’re working to complete your verification as fast as possible.",
    "kycPendingTitle": "ID Verification in Progress",
    "kycSoftCta": "Verification Needed →",
    "kycSoftDetail": "You can try again to correct issues with your verification.",
    "kycSoftTitle": "ID Verification Didn’t Work",
    "kycOptionCloseDetail": "Exit and come back to this deposit later.",
    "kycOptionCloseTitle": "Close deposit",
    "kycOptionMaxDetail": "Up to {{max}} before verification.",
    "kycOptionMaxDetailUnknown": "Up to your current limit before verification.",
    "kycOptionMaxTitle": "Deposit max",
    "kycOptionRedoDetail": "Confirm your details and documentation and let’s give it another try.",
    "kycOptionRedoTitle": "Re-do ID verification",
    "kycOptionSupportDetail": "Contact us to resolve issues related to your identity verification requirements.",
    "kycOptionSupportTitle": "Get help & support",
    "kycOptionsHardTitle": "We are unable to increase your deposit limit after ID verification.",
    "kycOptionsLabel": "Right now you can:",
    "kycOptionsPendingTitle": "Your ID Verification is still being processed. Your deposit limits have not changed yet.",
    "kycOptionsSoftTitle": "Your ID Verification did not work. Try verifying again to correct possible issues with the last attempt.",
    "kycTitle": "Identity Verification",
    "otpDetailAnyEmail": "Code sent to your email",
    "otpDetailAnyPhone": "Code sent to your phone",
    "otpDetailEmail": "Enter the code sent to\n{{email}}",
    "otpDetailPhone": "Enter the code sent to\n{{phone}}",
    "otpError": "Invalid code. Please try again or\nrequest a new code.",
    "otpExpired": "That code has expired. Request a new one.",
    "otpRateLimited": "Too many codes were requested. Please wait before trying again.",
    "otpRateLimitedTitle": "Please wait before requesting another code",
    "otpPlaceholder": "6-digit code",
    "otpResend": "Resend",
    "otpResendPrompt": "Need a new code?",
    "otpTitle": "Enter the code",
    "payButton": "Deposit with Apple Pay",
    "paySheetPay": "Pay",
    "paySheetTitle": "Confirm with Apple Pay",
    "paySheetTotal": "Total {{amount}}",
    "phoneCountryLabel": "Country code",
    "phoneCountrySearch": "Search countries",
    "phonePlaceholder": "Your phone number",
    "processing": "Processing your deposit…",
    "pendingOrderTitle": "You have an unfinished deposit",
    "pendingOrderDetail": "Resume your {{amount}} deposit, or cancel it to continue with a new amount.",
    "resumeDeposit": "Resume deposit",
    "cancelDeposit": "Cancel deposit",
    "quoteExpired": "That price expired",
    "quoteFailed": "Couldn't get a price",
    "redirectDetail": "We'll update this screen as soon as you're back.",
    "redirectReopen": "Open the browser again",
    "redirectTitle": "Finish your payment in the browser",
    "refunded": "Deposit refunded",
    "refusalDetails": "Please check what you entered and try again.",
    "refusalDetailsTitle": "Some of these details need another look",
    "refusalLimits": "Try a smaller amount or another payment method.",
    "refusalLimitsTitle": "This payment method can't take that amount",
    "refusalUnavailable": "This is on our end - try again in a moment or try a lower amount.",
    "refusalUnavailableTitle": "No payment option is available right now",
    "requote": "Get a new quote",
    "reviewTitle": "Confirm your deposit",
    "orderConfirmingTitle": "Confirming your payment",
    "orderConfirmingDetail": "Your payment went through. We're recording your deposit, which can take a moment.",
    "submitFailed": "That didn't go through",
    "paymentFailed": "Please try again",
    "submitting": "Submitting",
    "stripeAuthDetail": "We'll use {{email}} to continue securely with Link.",
    "stripeAuthorizing": "Continue in Stripe",
    "stripeAuthorizingDetail": "Complete Link verification and consent in the Stripe window.",
    "stripeAuthTitle": "Continue with Stripe",
    "stripeAuthFailed": "We couldn't start your Stripe session. Try again.",
    "stripeKycInfoFailed": "We couldn't save your details with Stripe. Check them and try again.",
    "stripeRegistrationFailed": "We couldn't create your Link account. Check your details and try again.",
    "success": "Deposit complete",
    "successDetail": "Your balance will update in a moment.",
    "termsNotice": "By continuing you agree to the provider’s\n<terms>Terms</terms>.",
    "unsupported": "This step isn't available yet",
    "verifying": "Verifying your identity…",
    "verifyingDetail": "This usually takes under a minute.",
    "verifyingSlow": "Still verifying",
    "verifyingSlowDetail": "You can close this and check back shortly.",
    "coinbaseTermsNotice": "By continuing you agree to Coinbase’s\n<terms>Terms</terms>, <agreement>User Agreement</agreement>, and <privacy>Privacy Policy</privacy>.",
    "contactInvalidEmail": "Please enter a valid email address",
    "kycIntroTitle": "Let’s verify your identity",
    "kycAdditionalTitle": "We need a little more info",
    "kycAdditionalDetail": "Additional verification is required to unlock higher deposit limits. These higher limits will be available as soon as verification is completed.",
    "kycFindOutMore": "Find out more",
    "kycR2Consent": "By continuing you consent to Fun verifying your identity and sharing results with select payment providers.",
    "kycAgreeContinue": "Agree & Continue",
    "kycSsnLastFour": "Please provide the\nlast 4 digits of your SSN",
    "kycSsnProtection": "We are required by U.S. law to collect an SSN for purposes of identity verification. Your information is protected by bank-level encryption.",
    "kycDetailCountry": "Your Country",
    "kycCountry": "Country",
    "kycDetailOccupation": "Your Occupation",
    "kycDetailPurpose": "Please provide your purpose of transaction",
    "kycOccupation": "Occupation",
    "kycPurpose": "Purpose of transaction",
    "kycDetailPhone": "Your mobile number",
    "kycDetailEmployment": "Your employment status",
    "kycDetailSourceOfWealth": "Your source of wealth",
    "kycDetailIncome": "Your gross annual income",
    "kycDetailActivity": "Your monthly activity",
    "kycIncomeCaption": "Before tax, in your local currency",
    "kycReviewTitle": "Thanks! Your information has been received and is being reviewed.",
    "kycHoldTitle": "Thanks! Your information has been received. We need a bit more time to complete a review.",
    "kycRestrictedTitle": "Your account has been restricted.",
    "regionUnsupportedTitle": "Your region is not supported.",
    "kycAnyQuestions": "Have any questions?",
    "kycGetHelpSupport": "Get help and support",
    "otpVerified": "Code verified",
    "authConnectFailedTitle": "We couldn't connect your {{provider}} account",
    "authConnectFailedDetail": "Start over to sign in from the beginning.",
    "kycUnavailableTitle": "Verification is temporarily unavailable.",
    "kycUnavailableNetwork": "Try again in a moment or leave and come back later.",
    "kycUnavailableProviderTitle": "We couldn't verify you.",
    "kycUnavailableProvider": "Something went wrong on our end. Contact support and we'll pick it up from there.",
    "contactSupport": "Contact support",
    "kycDocumentTitle": "Verifying your ID",
    "kycDocumentDetail": "We need to check your ID to complete your verification. ID verification is powered by {{provider}}.",
    "kycDocumentContinue": "Verify ID with {{provider}}",
    "applePayUnavailableTitle": "Apple Pay is temporarily unavailable.",
    "kycLimitNotice": "Daily limit reached: verify now to instantly unlock higher limits.",
    "contactEmailRejected": "This email address cannot be verified, please choose another address.",
    "contactReverifyPhone": "Please verify your phone number again.",
    "coinbaseCardSoftDeclined": "Your bank declined this payment. Try another card in Apple Pay, or check with your bank.",
    "coinbaseCardHardDeclined": "Your bank declined this card. Use a different card in Apple Pay.",
    "coinbaseCardRiskDeclined": "This payment couldn't be approved. Try a different card in Apple Pay.",
    "coinbaseInvalidCard": "Check the card and billing address in Apple Pay, then try again.",
    "coinbaseInsufficientBalance": "That card doesn't have enough for this deposit.",
    "coinbasePrepaidCard": "Prepaid cards aren't accepted. Use a debit card in Apple Pay.",
    "coinbaseRegionUnsupported": "Card deposits aren't available where you are.",
    "coinbasePermissionDenied": "This payment method isn't available on your account.",
    "coinbaseWeeklyLimit": "This would go over your weekly card deposit limit. Try a smaller amount.",
    "coinbaseLifetimeCount": "You've used every card deposit available without a Coinbase account.",
    "coinbaseDailyCount": "You've reached today's card deposit limit. Try again tomorrow.",
    "coinbaseBillingZip": "The billing ZIP code didn't match your card. Check it and try again.",
    "coinbaseBillingAddress": "The billing address is incomplete. Check it and try again.",
    "coinbaseBillingName": "The cardholder name wasn't accepted. Check it and try again.",
    "coinbaseSessionExpired": "This payment session expired. Start the deposit again.",
    "coinbaseNetworkUnsupported": "This network isn't available where you are.",
    "coinbaseAssetUnsupported": "This token isn't available where you are.",
    "coinbaseProviderError": "Coinbase couldn't complete this. Try again in a moment.",
    "coinbaseBuyFailed": "The purchase couldn't be completed. Your card wasn't charged.",
    "coinbaseSendFailed": "The deposit couldn't be delivered. Your card will be refunded.",
    "coinbaseAvsFailed": "Your billing address couldn't be verified. Check it with your bank and try again.",
    "cancelled": "Deposit cancelled",
    "sessionExpired": "Your session expired. Sign in again to continue your deposit.",
    "accountIneligibleTitle": "Deposits aren't available for this account",
    "accountIneligibleDetail": "Contact support if you think this is a mistake."
  },
  "fops": {
    "bankTransferSubtitle": "{{limit}} limit · 1-2 days",
    "bankTransferTime": "1-2 days",
    "instant": "Instant",
    "limit": "{{limit}} limit"
  },
  "networks": {
    "chainFallback": "Chain {{chainId}}",
    "minimum": "${{min}} minimum"
  },
  "qrCode": {
    "title": "QR Code"
  },
  "selectChain": {
    "subtitle": "Choose a network to deposit from",
    "title": "Deposit crypto"
  },
  "selectMethod": {
    "crypto": "Crypto",
    "depositTo": "Deposit to",
    "errorMessage": "There was a problem loading data.\nCheck your internet and try again.",
    "errorTitle": "Something went wrong",
    "loadingMethods": "Loading payment methods",
    "noLimit": "No limit",
    "payWith": "Pay with",
    "title": "Add money"
  },
  "selectReceiveToken": {
    "availableTokens": "Available tokens",
    "moreTokens_one": "+{{count}} token",
    "moreTokens_other": "+{{count}} tokens",
    "searchTokens": "Search for a token",
    "selectChain": "Select chain",
    "selectToken": "Select token",
    "title": "Receive token & chain"
  },
  "transferCrypto": {
    "changeChain": "Change chain",
    "depositAddressLabel": "Your deposit address",
    "generating": "Generating…",
    "selectedChain": "Selected chain",
    "share": "Share",
    "shareAddress": "Share address",
    "showQrCode": "Show QR code",
    "title": "Transfer Crypto"
  },
  "withdraw": {
    "belowMinimumMessage": "Your balance is below the minimum for a cash withdrawal.",
    "belowMinimumTitle": "Balance too low",
    "cashMethodsError": "Something went wrong loading cash-out methods. You can still withdraw with crypto.",
    "noCashMethods": "Cash-out methods like bank and card aren't available in your region. You can still withdraw with crypto.",
    "title": "Withdraw",
    "unavailableMessage": "Cash withdrawals aren't available in your region right now.",
    "unavailableTitle": "Withdrawals unavailable"
  },
  "withdrawAddress": {
    "breakdown": "You'll receive approximately {{amount}}. This may vary slightly due to network conditions. This trade won't execute at a price lower than {{minimum}}. Your transaction should complete within a few seconds.",
    "breakdownTitle": "Transaction Breakdown",
    "clear": "Clear",
    "detected": "Wallet detected",
    "notFound": "No wallet found",
    "paste": "Paste",
    "requested": "Withdrawal Requested",
    "title": "Withdraw {{amount}}",
    "useConnected": "Use Connected",
    "withdrawNow": "Withdraw Now",
    "withdrawing": "Withdrawing",
    "withdrew": "Withdrew",
    "youllReceive": "You'll receive"
  },
  "withdrawAmount": {
    "amountLabel": "Amount",
    "delete": "Delete",
    "swapDenomination": "Switch between dollars and tokens",
    "useMax": "Use Max"
  },
  "withdrawCrypto": {
    "aboveBalance": "Insufficient balance",
    "addressPlaceholder": "Wallet address",
    "available": "{{amount}} {{symbol}} available",
    "belowFee": "Amount must be more than the {{amount}} fee",
    "belowMinimum": "Minimum Amount is {{amount}}",
    "ctaInvalidForChain": "Address isn't valid for this network",
    "ctaMaxExceeded": "Max amount exceeded",
    "ctaRecipientSameAsSource": "Choose a different address",
    "ctaSelectDestination": "Select a destination",
    "errorGeneric": "Withdrawal failed. Please try again.",
    "errorInsufficientGas": "Insufficient gas to complete the transaction.",
    "errorSwitchChain": "Unable to switch networks. Please ensure your wallet supports the network.",
    "failedMessage": "{{amount}} didn't reach the recipient. Contact support if the funds don't come back.",
    "failedTitle": "Withdrawal didn't complete",
    "max": "Max",
    "methodSubtitle": "No limit",
    "methodTitle": "Crypto address",
    "quoteFailed": "Failed fetching the swap quote. Please try again.",
    "receiveAs": "Receive as",
    "refundedMessage": "{{amount}} was returned to your wallet.",
    "riskyAddress": "This wallet address cannot be used due to restrictions.",
    "selectSource": "Select source",
    "sendFrom": "Withdraw from",
    "successPendingMessage": "{{amount}} is settling on-chain. You can close this.",
    "successPendingTitle": "Withdrawal sent",
    "title": "Withdraw crypto",
    "unsupportedRecipient": "Unsupported recipient address"
  },
  "withdrawLighter": {
    "delayHours": "{{hours}} h",
    "delayHoursMinutes": "{{hours}} h {{minutes}} min",
    "delayMinutes": "{{minutes}} min",
    "delaySecond": "1 second",
    "delaySeconds": "{{seconds}} seconds",
    "fastDisclaimer": "USDC Perps only · Multiple chains · Instant",
    "fastDisclaimerUnified": "USDC only · Multiple chains · Instant",
    "methodFast": "Fast",
    "methodSecure": "Native Bridge",
    "secureDisclaimer": "All tokens · Ethereum chain only · {{delay}}",
    "secureFallbackDelay": "60+ minutes"
  },
  "withdrawNado": {
    "errorAmountTooLow": "Amount is too low to cover the Nado withdrawal fee.",
    "errorBalanceChanged": "Your withdrawable balance changed. Tap Max and try again.",
    "errorInvalidNonce": "This withdrawal request expired. Please try again.",
    "errorNetwork": "Can't reach Nado right now. Please try again.",
    "errorNoPriorDeposit": "Deposit to Nado before withdrawing.",
    "errorRateLimited": "Too many requests. Please wait a moment and try again.",
    "errorSignerMismatch": "Switch back to the wallet that owns this Nado account to withdraw.",
    "errorUnconfirmed": "We couldn't confirm your withdrawal. Check your Nado balance before trying again.",
    "errorWithdrawRisk": "Nado's 24-hour withdrawal limit was reached. Please try again later."
  },
  "paymentMethods": {
    "applePay": "Apple Pay",
    "card": "Card"
  },
  "lockedTransfer": {
    "amountInfoTitle": "Send amount",
    "amountInfoDescription": "This is the amount you should send such that you deposit {{amount}}. Funds sent above this amount won’t be deposited and need support to recover.",
    "amountLoading": "Calculating…",
    "amountUnavailable": "Amount unavailable",
    "title": "Deposit Crypto",
    "send": "Send",
    "amount": "Amount",
    "address": "One-time use deposit address",
    "copyAmount": "Copy amount",
    "amountCopied": "Amount copied",
    "showFullAddress": "Show full address",
    "tokenOnChain": "{{token}} on {{chain}}"
  },
  "selectAsset": {
    "emptyChains": "No supported chains available",
    "combinedTitle": "Token & chain you’ll send",
    "title": "Select an asset",
    "empty": "No supported assets available"
  }
}
